let mutations = {
  set_operator (state, data) {
    state.operators = data
  },
  set_region (state, data) {
    state.regions = data
  },
  set_recharge_amount (state, data) {
    state.amount = data
  },
  set_recharge_operator (state, data) {
    state.operator = data
  },
  set_recharge_region (state, data) {
    state.region = data
  },
  set_recharge_account_id (state, data) {
    state.recharge_account_id = data
    state.valid_recharge_account_id = true
  },
  set_plans (state, data) {
    state.plans = data
    state.filteredPlans = data
  },
  set_plan_categories (state, data) {
    state.planCategories = data
    state.planCategories.unshift('All')
  },
  filter_plans (state, data) {
    if (data === 'All') {
      state.filteredPlans = state.plans
    } else {
      state.filteredPlans = state.plans.filter(plan => plan.category.replace(/\s/g, '') === data)
    }
  },
  set_selected_plan (state, data) {
    state.selectedPlan = data.amount
    state.selectedPlanDescription = data.description
  },
  set_selected_category (state, data) {
    state.selectedCategory = data
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/recharge/mutations.js